const initialState = {
  itemAdded: null,
  itemRemoved: null,
  fetching: false,
  fetched: false,
  error: null,

  data: [],
  filters: {},
}

let newData
let index
let itemRemoved

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'BUCKET_LIST_INITIALIZE_FROM_QUERY_STRING': {
      return {
        ...state,
        filters: action.payload,
      }
    }

    case 'BUCKET_LIST_FILTERS_UPDATE': {
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.payload,
        },
      }
    }

    case 'MY_BUCKETLIST_FETCH_PENDING':
      return {
        ...state,
        itemAdded: null,
        itemRemoved: null,
        fetching: true,
      }

    case 'MY_BUCKETLIST_FETCH_REJECTED':
      return {
        ...state,
        fetching: false,
        error: action.payload,
      }

    case 'MY_BUCKETLIST_FETCH_FULFILLED':
      return {
        ...state,
        fetching: false,
        fetched: true,
        data: action.payload.data,
      }

    case 'BUCKET_LIST_ADD_PENDING':
      return {
        ...state,
        itemAdded: null,
        itemRemoved: null,
        fetching: true,
      }

    case 'BUCKET_LIST_ADD_REJECTED':
      return {
        ...state,
        fetching: false,
        error: action.payload,
      }

    case 'BUCKET_LIST_ADD_FULFILLED':
      newData = state.data.slice()
      newData.push(action.payload.data)
      return {
        ...state,
        data: newData,
        itemAdded: action.payload.data,
        fetching: false,
      }

    case 'BUCKET_LIST_REMOVE_PENDING':
      return {
        ...state,
        itemAdded: null,
        itemRemoved: null,
        fetching: true,
      }

    case 'BUCKET_LIST_REMOVE_REJECTED':
      return {
        ...state,
        fetching: false,
        error: action.payload,
      }

    case 'BUCKET_LIST_REMOVE_FULFILLED':
      itemRemoved = action.payload.data
      index = state.data.findIndex(
        (item) => item[item.type].id === itemRemoved[itemRemoved.type].id,
      )
      newData = state.data.slice()
      newData.splice(index, 1)
      return {
        ...state,
        data: newData,
        itemRemoved,
        fetching: false,
      }

    default:
      return state
  }
}
